/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, Heading, HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { ConsultaSeguimentoPerguntaStatusEnum } from '../model-consultaSeguimento'
import {
  ConsultaSeguimentoPerguntaStatusTag,
  ConsultaSeguimentoPerguntaStatusTagEnum,
} from './ConsultaSeguimentoPerguntaStatusTag'

interface ConsultaSeguimentoPerguntaHeaderProps {
  pergunta: MChatPerguntaEnum
  title: React.ReactNode | string
  status: ConsultaSeguimentoPerguntaStatusEnum
  description?: string
  field?: React.ReactNode
  required?: boolean
}

export function ConsultaSeguimentoPerguntaHeader(props: Readonly<ConsultaSeguimentoPerguntaHeaderProps>) {
  const { pergunta, title, status, description, field, required = false } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const numberOfPergunta = getMChatPerguntaNumber(pergunta)

  return (
    <Box style={styles.box[status]}>
      <HFlow hSpacing={2} justifyContent='space-between'>
        <VFlow vSpacing={0}>
          <HFlow hSpacing={0.5} style={styles.tagContainer}>
            <Text>Pergunta {numberOfPergunta}</Text>
            {status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU && (
              <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU} />
            )}
            {status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU && (
              <ConsultaSeguimentoPerguntaStatusTag type={ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU} />
            )}
          </HFlow>
          {description && <Text style={styles.description}>{description}</Text>}
          <Heading level={3}>
            {title}
            {required && <span css={styles.required}> *</span>}
          </Heading>
        </VFlow>
        {field}
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  required: css`
    color: ${theme.pallete.status.danger.main};
  `,
  tagContainer: css`
    height: 1.5rem;
    display: grid;
    align-items: center;
  `,
  description: css`
    white-space: pre-line;
  `,
  box: {
    [ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO]: css`
      border-color: ${theme.pallete.gray.c80};
      background-color: ${theme.pallete.gray.c90};
    `,
    [ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU]: css`
      border-color: ${colors.green.c80};
      background-color: ${colors.green.c90};
    `,
    [ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU]: css`
      border-color: ${colors.red.c80};
      background-color: ${colors.red.c90};
    `,
  },
})
